import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0037',
    ecrans: ['00-2',
             '01-2']
});
